import { fetchBaseQuery, createApi } from "@reduxjs/toolkit/query/react";

// Function to get the token from localStorage
export const getTokenFromLocalStorage = () => {
  let authtoken = localStorage.getItem("authToken");
  return authtoken;
};
const apiUrl = process.env.REACT_APP_API_URL;
const customBaseQuery = async (args, api, extraOptions) => {
  const token = getTokenFromLocalStorage();
  // console.log("Token here to be displayed=?>", token);
  const baseQuery = fetchBaseQuery({
    baseUrl: `${apiUrl}/api`,
    prepareHeaders: (headers) => {
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  });
  return baseQuery(args, api, extraOptions);
};

export const apiSlice = createApi({
  baseQuery: customBaseQuery,
  tagTypes: ["Events", "Tickets", "Users"],
  endpoints: (builder) => ({
    updateUserProfile: builder.mutation({
      query: (userData) => ({
        url: "/user/update-user-profile",
        method: "PUT",
        body: userData,
      }),
    }),
    addTicketType: builder.mutation({
      query: (ticketTypeData) => ({
        url: "/user/add-ticket-category",
        method: "POST",
        body: ticketTypeData,
      }),
    }),
    // The same api is used more than once
    getTicketTypes: builder.query({
      query: () => "/user/get-ticket-category",
    }),
    deleteTicketType: builder.mutation({
      query: (ticketTypeId) => ({
        url: "/user/delete-ticket-category",
        method: "DELETE",
        body: { ticketTypeId },
      }),
    }),
    updateTicketType: builder.mutation({
      query: ({ ticketTypeId, typeName }) => ({
        url: "/user/update-ticket-category",
        method: "PUT",
        body: { ticketTypeId, typeName },
      }),
    }),
    getProfileInformation: builder.query({
      query: () => "/user/user-info",
    }),
    changePassword: builder.mutation({
      query: (passwordData) => ({
        url: "/user/change-password",
        method: "PUT",
        body: passwordData,
      }),
    }),
    contactUs: builder.mutation({
      query: (contactUsData) => ({
        url: "/user/contact",
        method: "POST",
        body: contactUsData,
      }),
    }),
    teamInvitation: builder.mutation({
      query: (invitationLink) => ({
        url: "/user/team-invitation",
        method: "POST",
        body: invitationLink,
      }),
    }),
    createEvent: builder.mutation({
      query: (event) => ({
        url: `event/create-event`,
        method: "POST",
        body: event,
      }),
    }),
    getEvents: builder.query({
      query: (params) => ({
        url: "event/fetch-events",
        method: "GET",
        params: {
          eventName: params.eventName,
          organizerName: params.organizerName,
          status: params.status,
          startDate: params.startDate,
          endDate: params.endDate,
          page: params.page || 1, // default to 1
          limit: params.limit || 4,
        },
      }),
    }),

    getInvitedEvents: builder.mutation({
      query: (userData) => ({
        url: "user/team-invitations",
        method: "POST",
        body: userData,
      }),
    }),
    // Need to remove this since its already
    getTicketCategory: builder.query({
      query: () => "user/get-ticket-category",
    }),
    createTicket: builder.mutation({
      query: (ticketData) => ({
        url: "/event/create-ticket",
        method: "POST",
        body: ticketData,
      }),
    }),
    publicEvents: builder.query({
      query: () => ({ url: "/events/public", method: "GET" }),
    }),
    bookingDetails: builder.mutation({
      query: (eventId) => ({
        url: "/booking/booking-deatils",
        method: "POST",
        body: eventId,
      }),
    }),
    addTicketToGoogleWallet: builder.mutation({
      query: (ticketData) => ({
        url: "/booking/google-wallet",
        method: "POST",
        body: ticketData,
      }),
    }),
    addTicketToAppleWallet: builder.mutation({
      query: (ticketData) => ({
        url: "/booking/apple-wallet",
        method: "POST",
        body: ticketData,
      }),
    }),
    bookEvent: builder.mutation({
      query: (bookingData) => ({
        url: "/booking/book-event",
        method: "POST",
        body: bookingData,
      }),
    }),
    identifyTax: builder.mutation({
      query: (eventId) => ({
        url: "/booking/identify-tax",
        method: "POST",
        body: eventId,
      }),
    }),
    searchEvents: builder.mutation({
      query: ({ eventName, location, dateRange, status, page, limit }) => ({
        url: "/event/search-event",
        method: "POST",
        body: {
          eventName,
          location,
          dateRange,
          status,
          page,
          limit,
        },
      }),
    }),
    searchEventById: builder.mutation({
      query: ({ eventId }) => ({
        url: "/event/get-event-by-id",
        method: "POST",
        body: {
          eventId,
        },
      }),
    }),
    getBookedEvents: builder.query({
      query: (params) => ({
        url: "booking/getBookedEvents",
        method: "GET",
        params: {
          eventName: params.eventName,
          organizerName: params.organizerName,
          status: params.status,
          startDate: params.startDate,
          endDate: params.endDate,
          page: params.page || 1,
          limit: params.limit || 3,
        },
      }),
    }),
    getDashStats: builder.query({
      query: () => ({ url: "/dashboard/getDashboardStats", method: "GET" }),
    }),
    getUserSales: builder.query({
      query: () => ({ url: "/dashboard/getUserEventSales", method: "GET" }),
    }),
    eventDetail: builder.mutation({
      query: ({ eventId }) => ({
        url: "/event/event-details",
        method: "POST",
        body: { eventId },
      }),
    }),

    deleteEvent: builder.mutation({
      query: ({ eventId, userId }) => ({
        url: "/event/delete-event",
        method: "DELETE",
        body: { eventId, userId },
      }),
    }),

    acceptInvitation: builder.mutation({
      query: ({ invitationId, eventId }) => ({
        url: "/event/accept-invite",
        method: "POST",
        body: { invitationId, eventId },
      }),
    }),

    declineInvitation: builder.mutation({
      query: ({ invitationId }) => ({
        url: "/event/decline-invite",
        method: "DELETE",
        body: { invitationId },
      }),
    }),
    getCalenderEvents: builder.query({
      query: () => ({
        url: "event/calender-events",
        method: "GET",
      }),
    }),
    onboardSuccess: builder.query({
      query: (accountId) => ({
        url: `payment/onboardSuccess?accountId=${accountId}`,
        method: "GET",
      }),
    }),
    verifyCode: builder.mutation({
      query: ({ code, eventId, userId }) => ({
        url: "/booking/verify-alphaNumeric-code",
        method: "POST",
        body: { code, eventId, userId },
      }),
    }),
    verifyByName: builder.mutation({
      query: ({ name, eventId, userId }) => ({
        url: "/booking/booking-details-by-name",
        method: "POST",
        body: { name, eventId, userId },
      }),
    }),
    verifyBookingByQr: builder.mutation({
      query: ({ eventId, userId, bookingId, ticketCode }) => ({
        url: "/booking/verify-by-event-and-user",
        method: "POST",
        body: { eventId, userId, bookingId, ticketCode },
      }),
    }),
    verifyTicketAuthentication: builder.mutation({
      query: (ticketCode) => ({
        url: "/booking/verify-ticket-authentication",
        method: "POST",
        body: { ticketCode },
      }),
    }),
    getTicketsByBookingId: builder.mutation({
      query: ({ bookingId, eventId }) => ({
        url: "/booking/tickets-by-bookingId",
        method: "POST",
        body: { bookingId, eventId },
      }),
    }),
    googleLogin: builder.mutation({
      query: (data) => ({
        url: "/auth/google",
        method: "POST",
        body: data,
      }),
    }),
    inviteEvent: builder.mutation({
      query: (data) => ({
        url: "/auth/invite",
        method: "POST",
        body: data,
      }),
    }),
    ticketCreation: builder.mutation({
      query: (data) => ({
        url: "/customTicket/create",
        method: "POST",
        body: data,
      }),
    }),
    fetchTicketCreation: builder.query({
      query: (data) => ({
        url: "/customTicket/fetch",
        method: "GET",
        body: data,
      }),
    }),
  }),
});

export const {
  useAddTicketToGoogleWalletMutation,
  useAddTicketToAppleWalletMutation,
  useInviteEventMutation,
  useFetchTicketCreationQuery,
  useTicketCreationMutation,
  useGoogleLoginMutation,
  useIdentifyTaxMutation,
  useGetTicketsByBookingIdMutation,
  useVerifyByNameMutation,
  useVerifyBookingByQrMutation,
  useVerifyTicketAuthenticationMutation,
  useVerifyCodeMutation,
  useGetCalenderEventsQuery,
  useOnboardSuccessQuery,
  useDeclineInvitationMutation,
  useAcceptInvitationMutation,
  useDeleteEventMutation,
  useEventDetailMutation,
  useGetDashStatsQuery,
  useGetUserSalesQuery,
  useGetBookedEventsQuery,
  useBookEventMutation,
  useBookingDetailsMutation,
  useGetInvitedEventsMutation,
  useUpdateUserProfileMutation,
  useAddTicketTypeMutation,
  useGetTicketTypesQuery,
  useDeleteTicketTypeMutation,
  useUpdateTicketTypeMutation,
  useGetProfileInformationQuery,
  useChangePasswordMutation,
  useContactUsMutation,
  useTeamInvitationMutation,
  useCreateEventMutation,
  useGetEventsQuery,
  useGetTicketCategoryQuery,
  usePublicEventsQuery,
  useCreateTicketMutation,
  useSearchEventsMutation,
  useSearchEventByIdMutation,
} = apiSlice;
